<div class="chart-wrapper">
    <svg class="circle-chart" viewBox="0 0 160 160" preserveAspectRatio="xMidYMid meet" style="max-height: 140px">
        <!-- pozadí -->
        <circle cx="80" cy="80" r="70" fill="none" [attr.stroke]="defaultStroke" stroke-width="12" />

        <!-- progress -->
        <circle
            class="widget-form-participant-bar--home"
            cx="80"
            cy="80"
            r="70"
            fill="none"
            [attr.stroke]="defaultMainStroke"
            stroke-width="12"
            stroke-linecap="round"
            transform="rotate(-90 80 80)"
            stroke-dasharray="439.8"
            stroke-dashoffset="439.8"
        >
            <!-- to = 439.8 × (1 − procenta) -->
            <animate attributeName="stroke-dashoffset" from="439.8" [attr.to]="prct" dur="1.2s" fill="freeze" />
        </circle>

        <!-- text -->
        <text
            x="80"
            y="80"
            text-anchor="middle"
            dominant-baseline="middle"
            font-size="30"
            font-weight="600"
            [attr.fill]="defaultFill"
        >
            <ng-content></ng-content>
        </text>
    </svg>
    <div class="text-center">{{ text }}</div>
</div>
